module.exports = __webpack_public_path__ + "static/logo-176b5d0844a4e57da9b164a5e3c297ad.svg";